module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eDozH"))).then(() => parcelRequire('ljYL6'));